import React from "react"

interface IProps {
  count: number
  top?: string
}

const Counter: React.FC<IProps> = ({ count, top = "-3px" }: IProps): JSX.Element => {
  if (!count) return null

  const countText = count < 99 ? count.toString() : "9+"

  return (
    <span
      className="absolute right-0 bg-ch-red-500 text-white rounded-full w-5 h-5 text-sm flex justify-center items-center p-2 -mt-2 -mr-2"
      style={{
        top: top
      }}
    >
      {countText}
    </span>
  )
}

export default Counter
